import type {RecommendationSourceType} from '@package/shared'
import {IconBrandGithub, IconCalendar, IconLayoutKanban} from '@tabler/icons-react'
import {Badge} from '@mantine/core'

type Props = {
  type: RecommendationSourceType
}

export const SourceBadge = ({type}: Props) => {
  const sourceName = {
    ical: 'Calendar',
    'github-commit': 'GitHub',
    'jira-issue': 'Jira',
  }[type]
  return (
    <Badge size={'lg'} circle pt={7} variant={'light'} title={`Source: ${sourceName}`}>
      {
        {
          ical: <IconCalendar size={18} stroke={1} />,
          'github-commit': <IconBrandGithub size={18} stroke={1} />,
          'jira-issue': <IconLayoutKanban size={18} stroke={1} />,
        }[type]
      }
    </Badge>
  )
}
